import { gql } from '@apollo/client'

const BASE_FLASH_CARD_FIELDS = gql`
  fragment BaseFlashCardTypeFields on FlashCardType {
    id
    name
    description
    link
    order
    membershipLevel
    flashCardGroup {
      id
      color
      title
    }
  }
`

export const FIND_ALL_FLASH_CARDS = gql`
  ${BASE_FLASH_CARD_FIELDS}
  query findAllFlashCard($query: FlashCardQueryInput = {}) {
    findAllFlashCard(query: $query) {
      count
      items {
        createdAt
        ...BaseFlashCardTypeFields
      }
    }
  }
`

export const CREATE_FLASH_CARDS = gql`
  mutation createFlashCard($createFlashCardInput: CreateFlashCardInput!) {
    createFlashCard(createFlashCardInput: $createFlashCardInput) {
      id
    }
  }
`

export const UPDATE_FLASH_CARDS = gql`
  mutation updateFlashCard($updateFlashCardInputFieldName: UpdateFlashCardInput!) {
    updateFlashCard(updateFlashCardInputFieldName: $updateFlashCardInputFieldName) {
      id
    }
  }
`

export const DELETE_FLASH_CARDS = gql`
  mutation removeFlashCard($removeFlashCardId: String!) {
    removeFlashCard(id: $removeFlashCardId) {
      affected
    }
  }
`

export const BULK_REMOVE_FLASH_CARDS = gql`
  mutation bulkRemoveFlashCard($ids: [LinkFlashCardInput!]!) {
    bulkRemoveFlashCard(ids: $ids) {
      affected
    }
  }
`

export const BULK_UPDATE_FLASH_CARDS = gql`
  mutation bulkUpdateFlashCard($bulkUpdateFlashCardInput: [BulkUpdateFlashCardInput!]!) {
    bulkUpdateFlashCard(bulkUpdateFlashCardInput: $bulkUpdateFlashCardInput) {
      id
    }
  }
`
